import { template as template_23636ba543dd419093fe6fc123956006 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import { LoadingIndicator } from '@cardstack/boxel-ui/components';
const Loading: TemplateOnlyComponent = template_23636ba543dd419093fe6fc123956006(`
  <div id='host-loading' data-test-host-loading>
    <div class='loading-container'>
      <div class='loading-indicator'>
        <LoadingIndicator @color='#00FFBA' />
      </div>
      <div class='loading-text'>Loading…</div>
    </div>
  </div>

  <style scoped>
    #host-loading {
      background-color: #686283;
      display: flex;
      align-items: center;
      justify-items: center;
      height: 100vh;
    }

    .loading-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
    }

    .loading-indicator {
      --boxel-loading-indicator-size: 20px;
    }

    .loading-text {
      color: #fff;
      font-size: 12px;
      font-weight: 600;
    }
  </style>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default RouteTemplate(Loading);
